// Режимы отображения
import {ValueOf} from "@typescript-eslint/eslint-plugin/dist/util";

export type ViewMode = 'columns' | 'list';

export enum ViewModeEnum {
	Columns= "columns",
	List = "list"
}

// Конфигурация для каждого режима
export interface ViewConfig {
  mode: ValueOf<typeof ViewModeEnum>;
  name: string;
  icon: string;
  description: string;
  breakpoint: number; // Минимальная ширина в px
  features: {
    horizontalScroll: boolean;
    columnWidth: 'fixed' | 'fluid' | 'full';
    taskHeight: 'compact' | 'normal' | 'expanded';
    dragAndDrop: 'full' | 'limited' | 'disabled';
    gestures: string[]; // Поддерживаемые жесты
  };
}

// Конфигурации всех режимов
export const VIEW_CONFIGS: Record<ViewMode, ViewConfig> = {
	'columns': {
		mode: ViewModeEnum.Columns,
		name: 'Доска задач',
		icon: '💻',
		description: 'Полнофункциональный режим с горизонтальными колонками',
		breakpoint: 1024,
		features: {
			horizontalScroll: true,
			columnWidth: 'fixed',
			taskHeight: 'normal',
			dragAndDrop: 'full',
			gestures: ['drag'],
		},
	},
	'list': {
		mode: ViewModeEnum.List,
		name: 'Список',
		icon: '📋',
		description: 'Вертикальный список всех задач',
		breakpoint: 0,
		features: {
			horizontalScroll: false,
			columnWidth: 'full',
			taskHeight: 'expanded',
			dragAndDrop: 'disabled',
			gestures: ['tap', 'long-press'],
		},
	},
};

// Состояние UI для адаптивности
export interface ResponsiveState {
  currentViewMode: ViewMode;
  availableModes: ViewMode[];
  screenWidth: number;
  screenHeight: number;
  isPortrait: boolean;
  touchSupported: boolean;
  gesturesEnabled: boolean;
}

// Жесты для мобильных устройств
export type GestureType =
  | 'swipe-left'
  | 'swipe-right'
  | 'swipe-up'
  | 'swipe-down'
  | 'tap'
  | 'long-press'
  | 'pinch';

export interface GestureEvent {
  type: GestureType;
  target: HTMLElement;
  startX: number;
  startY: number;
  endX?: number;
  endY?: number;
  duration: number;
}
